import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { SpinnerCitoPlus } from "jsx/components/CitoPlus/components/loadingLogo";
import axiosInstance from "../../../../../services/AxiosInstance";
import {
  notifyError,
  notifySuccess,
} from "jsx/components/CitoPlus/components/CitoPlusToastr";

const RESERVA_ESTADO_URL = "/api/v3/zonas-sociales/reservas/";
import { handleErrors } from "jsx/components/CitoPlus/components/ErrorHandlingComponent";

const STATUS_METADATA = Object.freeze({
  pendiente: { label: "Pendiente", variant: "warning" },
  confirmada: { label: "Confirmada", variant: "success" },
  cancelada: { label: "Cancelada", variant: "danger" },
});

const STATUS_OPTIONS = Object.keys(STATUS_METADATA);

const CambiarEstadoReservaModal = ({
  show,
  reservaUuid,
  currentEstado = "",
  onClose,
  onUpdated,
}) => {
  const [estado, setEstado] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (show) {
      setEstado(currentEstado || "pendiente");
      setDescripcion("");
    }
  }, [currentEstado, show]);

  const handleDismiss = useCallback(() => {
    setEstado("");
    setDescripcion("");
    onClose?.();
  }, [onClose]);

  const handleSubmit = useCallback(async () => {
    if (!reservaUuid) {
      notifyError("No se identificó la reserva a actualizar.");
      return;
    }

    if (!estado || !STATUS_METADATA[estado]) {
      notifyError("Selecciona un estado válido para la reserva.");
      return;
    }

    setIsUpdating(true);
    try {
      await axiosInstance.patch(`${RESERVA_ESTADO_URL}${reservaUuid}/estado/`, {
        estado,
        descripcion: descripcion || undefined,
      });
      notifySuccess("El estado de la reserva se actualizó correctamente.");
      onUpdated?.();
      handleDismiss();
    } catch (_error) {
      handleErrors(_error);
    } finally {
      setIsUpdating(false);
    }
  }, [descripcion, estado, handleDismiss, onUpdated, reservaUuid]);

  return (
    <Modal show={show} onHide={handleDismiss} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-exchange-alt me-2" />
          Cambiar estado de reserva
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-3">
          <div className="col-12">
            <label className="form-label fw-semibold" htmlFor="estado-select">
              Nuevo estado
            </label>
            <select
              id="estado-select"
              className="form-select"
              value={estado}
              onChange={(e) => setEstado(e.target.value)}
              disabled={isUpdating}
            >
              {STATUS_OPTIONS.map((key) => (
                <option key={key} value={key}>
                  {STATUS_METADATA[key].label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12">
            <label className="form-label" htmlFor="estado-descripcion">
              Comentarios (opcional)
            </label>
            <textarea
              id="estado-descripcion"
              className="form-control"
              rows={3}
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              placeholder="Motivo del cambio de estado..."
              disabled={isUpdating}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={handleDismiss}
          disabled={isUpdating}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={isUpdating}
        >
          {isUpdating ? (
            <>
              <i className="fas fa-circle-notch fa-spin me-2" />
              Actualizando...
            </>
          ) : (
            <>
              <i className="fas fa-check me-2" />
              Confirmar cambio
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CambiarEstadoReservaModal;
